export function mapEnumValue<T extends Record<string, string>, U extends Record<string, any>>(
	sourceEnum: T,
	targetEnum: U,
	value: T[keyof T] | undefined,
): U[keyof U] | undefined {
	if (value === undefined) {
		return undefined;
	}
	const targetKeys = Object.keys(targetEnum);
	const targetKey = targetKeys.find(key => sourceEnum[key as keyof T] === value);

	if (!targetKey) {
		console.error('No matching enum value found.');
		return undefined;
	}
	return targetEnum[targetKey as keyof U];
}
